import RowSpan from './RowSpan';
export default RowSpan;
